import type { WebVttRegion } from './WebVttRegion';

/**
 * A factory for creating WebVttRegion objects.
 *
 * @group WebVTT
 *
 * @beta
 */
export type WebVttRegionFactory = () => WebVttRegion;
